<template>
    <div class="components-container" id="mobileViewPort">
        <div id="mobileMode">

            <div id="queryArea">
                <div class="filter-container">
                    <div class="formItem">
                        <el-input v-model="queryForm.stuCode" placeholder="学号 / 姓名" clearable/>
                    </div>
                    <div class="formItem text-center">
                        <el-button @click="handleFilter" type="gray"><i class="el-icon-search"></i> 查询</el-button>
                        <el-button @click="handleReset" type="gray"><i class="el-icon-refresh"></i> 重置</el-button>
                        <el-button @click="queryDialogVisible = true" type="primary"><i class="el-icon-more"></i> 更多
                        </el-button>
                    </div>
                </div>
            </div>

            <!-- 搜索内容弹框 -->
            <el-dialog id="queryDialog" class="formDialog" title="查询信息" width="90%" :visible.sync="queryDialogVisible">
                <el-row>
                    <el-input v-model="queryForm.stuCode" placeholder="学号 / 姓名" clearable/>
                </el-row>
                <el-row>
                    <el-select v-model="queryForm.deptCode" filterable placeholder="系部" clearable
                               @change="changeOption('dept')">
                        <el-option v-for="item in comboOption.dept" :key="item.comboValue" :label="item.comboName"
                                   :value="item.comboValue"/>
                    </el-select>
                </el-row>
                <el-row>
                    <el-select v-model="queryForm.majorCode" filterable placeholder="专业" clearable
                               @change="changeOption('major')">
                        <el-option v-for="item in comboOption.major" :key="item.comboValue" :label="item.comboName"
                                   :value="item.comboValue"/>
                    </el-select>
                </el-row>
                <el-row>
                    <el-select v-model="queryForm.classCode" filterable placeholder="班级" clearable>
                        <el-option v-for="item in comboOption.class" :key="item.comboValue" :label="item.comboName"
                                   :value="item.comboValue"/>
                    </el-select>
                </el-row>
                <div slot="footer" class="dialog-footer text-center">
                    <el-button type="gray" @click="handleFilter">查 询</el-button>
                    <el-button style="margin-left: 10px;" type="gray" @click="handleReset">重 置</el-button>
                    <el-button style="margin-left: 10px;" @click="queryDialogVisible = false">取 消</el-button>
                </div>
            </el-dialog>

            <div id="listArea" @scroll="handleScroll" :style="{'height': divHeight-110+'px','overflow': 'auto'}">
                <div v-if="tableData==null || tableData.length==0" class="cardTips">没有实习信息记录</div>
                <div class="cardMain" v-for="(item,index) in tableData" :key="index">
                    <div class="cardText">
                        <p><label for="">学号：</label>{{ item.stuCode }}</p>
                        <p><label for="">姓名：</label>{{ item.stuName }}</p>
                    </div>
                    <div class="cardInput">
                        <el-button type="info" size="small" @click="detail(item)">详情</el-button>
                    </div>
                </div>
                <div v-if="total>2 && total>tableData.length" id="loadingTips">
                    <i class="el-icon-loading"></i>&nbsp;信息加载中，请稍候...
                </div>
            </div>

            <el-dialog id="mainDialog" class="formDialog" title="详情" :visible.sync="detailDialogVisible"
                       v-if="detailDialogVisible" width="90%">
                <el-scrollbar id="mainDialogScroll" ref="mainDialogScroll">
                    <el-form label-width="130px" label-position="left" width="100%">
                        <el-form-item label="学生">
                            {{ selectRowData.stuName }} - {{ selectRowData.stuCode }}
                        </el-form-item>
                        <el-form-item label="系部">
                            {{ selectRowData.deptName }}
                        </el-form-item>
                        <el-form-item label="专业">
                            {{ selectRowData.majorName }}
                        </el-form-item>
                        <el-form-item label="班级">
                            {{ selectRowData.className }}
                        </el-form-item>
                        <el-form-item label="实习推荐类型">
                            {{ parseType(selectRowData) }}
                        </el-form-item>
                        <el-form-item label="实习单位名称">
                            {{ selectRowData.unitName }}
                        </el-form-item>
                        <el-form-item label="实习岗位名称">
                            {{ selectRowData.postName }}
                        </el-form-item>
                        <el-form-item label="实习开始时间">
                            {{ selectRowData.beginTime }}
                        </el-form-item>
                        <el-form-item label="实习结束时间">
                            {{ selectRowData.endTime }}
                        </el-form-item>
                        <el-form-item label="实习薪资">
                            {{ selectRowData.salary }}
                        </el-form-item>
                        <el-form-item label="单位联系人姓名">
                            {{ selectRowData.unitContactsName }}
                        </el-form-item>
                        <el-form-item label="单位联系人职务">
                            {{ selectRowData.unitContactsDuty }}
                        </el-form-item>
                        <el-form-item label="单位联系人电话">
                            {{ selectRowData.unitContactsTel }}
                        </el-form-item>
                        <el-form-item label="单位联系人邮箱">
                            {{ selectRowData.unitContactsEmail }}
                        </el-form-item>
                        <el-form-item label="单位地址">
                            {{ selectRowData.unitAddress }}
                        </el-form-item>
                        <el-form-item label="岗位是否对口">
                            {{ parseSf(selectRowData.counterpart) }}
                        </el-form-item>
                        <el-form-item label="是否安排带教">
                            {{ parseSf(selectRowData.teaching) }}
                        </el-form-item>
                        <el-form-item label="是否提供住宿">
                            {{ parseSf(selectRowData.putUp) }}
                        </el-form-item>
                        <el-form-item label="入学前户籍信息">
                            {{ selectRowData.censusRegisterInfo }}
                        </el-form-item>
                        <el-form-item label="实习期间居住地址">
                            {{ selectRowData.residentialAddress }}
                        </el-form-item>
                        <el-form-item label="家庭电话">
                            {{ selectRowData.homeTel }}
                        </el-form-item>
                        <el-form-item label="学生手机号">
                            {{ selectRowData.stuPhone }}
                        </el-form-item>
                        <el-form-item label="学生邮箱">
                            {{ selectRowData.stuEmail }}
                        </el-form-item>
                    </el-form>
                </el-scrollbar>
            </el-dialog>


        </div>
    </div>
</template>

<script>
import {globalConfig} from "../../../../static/config";

export default {
    props: ['divHeight'],
    data() {
        return {
            queryForm: {
                pageNum: 1,
                rowNum: 10,
                stuCode: '',
                deptCode: '',
                majorCode: '',
                classCode: '',
                userCode:'',
                userRoles:[],
            },
            //表格数据
            tableData: [],
            //选中行的数据
            selectRowData: null,
            tableLoading: true,
            total: null,
            currentPage: 1,
            mainTableHeight: 500,
            comboOption: {
                dept: [],
                major: [],
                class: []
            },
            queryDialogVisible: false,
            detailDialogVisible: false
        }

    },
    mounted() {
        this.queryForm.userCode = this.userCode
        this.queryForm.userRoles = this.userRoles
        this.userInfo()
        this.initCombo()
    },
    methods: {
        userInfo() {
            this.$api.system.basic.userInfo({})
                .then((res) => {
                    this.queryForm.userCode = res.data.data.phone;
                    let arr = []
                    for (let roleCode in res.data.data.roles) {
                        if (roleCode === globalConfig.auth.admin || roleCode === globalConfig.auth.jwy_sx || roleCode === globalConfig.auth.fdy || roleCode === globalConfig.auth.sx_xbgly || roleCode === globalConfig.auth.sx_zyzdjs) {
                            arr.push(roleCode)
                        }
                    }
                    this.queryForm.userRoles = arr

                    // this.queryForm.userCode = '096136'
                    // this.queryForm.userRoles = []
                    // this.queryForm.userRoles.push(globalConfig.auth.jwy_sx)
                    // this.queryForm.userRoles.push('7')

                    this.queryList()
                }).catch((err) => {
                console.log(err);
            });
        },
        changeOption(type) {
            this.queryForm.classCode = ''
            let param = {}
            param = {
                "deptCode": this.queryForm.deptCode,
                "majorCode": this.queryForm.majorCode
            }

            if (type === 'dept') {
                this.queryForm.majorCode = ''
                this.$api.common.comboOption.major({
                    data: param
                }).then((res) => {
                    this.comboOption.major = res.data.data.comboData
                }).catch((err) => {
                    console.log(err);
                });
            }

            this.$api.common.comboOption.class({
                data: param
            }).then((res) => {
                this.comboOption.class = res.data.data.comboData
            }).catch((err) => {
                console.log(err);
            });
        },
        detail(rowData) {
            this.selectRowData = rowData
            this.detailDialogVisible = true
        },
        async queryList() {
            this.tableLoading = true;
            this.queryForm.pageNum = this.currentPage;

            await this.$api.postPracticeManage.stuPracticeInfo.queryList({
                data: this.queryForm,
            }).then((response) => {
                this.total = response.data.data.total;
                this.tableData = this.tableData.concat(response.data.data.list);
                this.tableLoading = false;
            }).catch((error) => {
                this.tableLoading = false;
                console.log(error);
            });
        },
        initCombo() {
            this.$api.postPracticeManage.stuPracticeInfo.initCombo({})
                .then((res) => {
                    this.comboOption.dept = res.data.data.dept
                    this.comboOption.major = res.data.data.major
                    this.comboOption.class = res.data.data.class
                })
                .catch((err) => {
                    console.log(err);
                });
        },
        handleFilter() {
            this.requeryList();
            this.queryDialogVisible = false;
        },
        requeryList() {
            this.scrollToTop();
            this.tableData.length = 0;
            this.currentPage = 1;
            this.queryList();
        },
        scrollToTop() {
            const ele = document.getElementById('listArea');
            if (ele) {
                ele.scrollTop = 0;
            }
        },
        handleReset() {
            this.queryForm.stuCode = '';
            this.queryForm.deptCode = '';
            this.queryForm.majorCode = '';
            this.queryForm.classCode = '';
            this.changeOption('dept')
            this.requeryList();
            this.queryDialogVisible = false;
        },
        handleScroll() {
            if (this.checkVisible() && !this.tableLoading && this.total > this.tableData.length) {
                this.currentPage++;
                this.queryList();
            }
        },
        checkVisible() {
            const ele = document.getElementById('loadingTips');
            if (ele) {
                let rect = ele.getBoundingClientRect();
                //获取当前浏览器的视口高度，不包括工具栏和滚动条
                //document.documentElement.clientHeight兼容 Internet Explorer 8、7、6、5
                let viewHeight = Math.max(document.documentElement.clientHeight, window.innerHeight);
                //bottom top是相对于视口的左上角位置
                //bottom大于0或者top-视口高度小于0可见
                return !(rect.bottom < 0 || rect.top - viewHeight >= 0);
            } else {
                return false;
            }
        },
        parseSf(str) {
            if (str === '1') {
                return '是'
            } else if (str === '0') {
                return '否'
            } else
                return ''
        },
        parseType(row) {
            if (row.typeCode === '1') {
                return '学校推荐'
            } else if (row.typeCode === '2') {
                return '自主联系'
            } else
                return ''
        }


    }
}
</script>

<style src="styles/mobile.css"></style>
<style scoped>
#mobileMode {
    width: auto;
}

#mobileMode #queryDialog {
    top: 130px;
}

#mobileMode #mainDialogScroll {
    height: 65vh;
    padding: 10px 20px;
}

#mobileMode #loadingTips {
    height: 30px;
    line-height: 30px;
    color: #9d9d9d;
    position: relative;
    bottom: 0;
    text-align: center;
}
</style>



// WEBPACK FOOTER //
// infoMobile.vue?4209902e